import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Knockout_Title } from '../../../../../utils/EN/Modals/SpotsModals';

const ModalKnockout = () => {
  return (
    <>
      <ModalVideo
        id="spot-knockout"
        dataText={Knockout_Title}
        videoSrc="https://player.vimeo.com/video/104952209?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_KNOCKOUT"
      />
    </>
  );
};

export default ModalKnockout;
